import { Stack, Typography } from "@mui/material";
import PageNotFoundImg from "../assets/images/404.png";
import Logo from "../components/Logo";
import { PrimaryButton } from "../components/form";
import { ArrowLeft } from "@phosphor-icons/react";

export default function PageNotFound() {

  const handleGoBack = () => {
    window.location.href = "/";
  }

  return (
    <Stack alignItems={"center"} textAlign={"center"} justifyContent={"space-around"} gap={4} py={2}>
      <Logo />
      <img src={PageNotFoundImg} style={{ maxHeight: 368, maxWidth: 368 }} />
      <Typography variant="heading2-helveticaNeue-medium">OPPS! 404 Page not Found!</Typography>
      <Typography variant="bodyLarge-helveticaNeue" color={"textSecondary"}>
        Uh-oh! We can’t seem to find the page you’re looking for.
        Let’s get you back home.
      </Typography>
      <PrimaryButton onClick={handleGoBack} startIcon={<ArrowLeft />}>Back</PrimaryButton>
    </Stack>
  )
}
